import { fetchClient } from "@/api/api";
import type {
	telegramConnectInput,
	telegramConnectOutput,
} from "@/api/custom_types";
import type { ApiError } from "@/utils/fetching";
import type { CustomMutationHook } from "@/utils/react-query";
import { useMutation } from "@tanstack/react-query";
import { TELEGRAM_SERVICE_KEYS } from "./keys";

export const useConnectTelegram: CustomMutationHook<
	telegramConnectInput,
	telegramConnectOutput
> = () => {
	return useMutation<telegramConnectOutput, ApiError, telegramConnectInput>({
		mutationKey: TELEGRAM_SERVICE_KEYS.useConnectTelegram(),
		mutationFn: async (params) => {
			const { data, error } = await fetchClient.POST(
				"/v1/fc/telegram/connect",
				{
					params: {
						query: params,
					},
					throwOnError: true,
				},
			);
			if (error) {
				throw error;
			}
			return data;
		},
	});
};
